// extracted by mini-css-extract-plugin
module.exports = {"boardView":"boardView__1Dj6Y","scrollable":"scrollable__BDdx1","scroll":"scroll__95+ow","arrowLeft":"arrowLeft__REtgm","arrowRight":"arrowRight__-thSn"};